
import React, { useEffect, useRef, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import SelectStaffModal from "./SelectStaffModal ";
import useFetchBookCategories from "../../hooks/useFetchBookCategories";
import useFetchBookSubCategories from "../../hooks/useFetchBookSubCategories";
import { ApiUrl } from "../../../ApiUrl";
import ReactPaginate from "react-paginate";

const AdmAttendanceEntry = () => {
  const [showModal, setShowModal] = useState(false);
  const [isModalVisible, setModalVisible] = useState(false);
  const navigate = useNavigate();
  const [bookCategory, setBookCategory] = useState("");
  const [bookSubCategory, setBookSubCategory] = useState("");
  const { subCategories } = useFetchBookSubCategories(bookCategory);
  const { categories } = useFetchBookCategories();
  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [addNo, setAddno] = useState("");
  const [barCode, setBarCode] = useState("");
  const [teacherId, setTeacherId] = useState("");
  const [bookTitle, setBookTitle] = useState("");

  // const [issueDate, setIssueDate] = useState("");
  const [bookBarcode, setBookBarcode] = useState("");
  // const [returnDate, setReturnDate] = useState("");
  const bookTitleRef = useRef(null);
  const openModal = () => setModalVisible(true);
  const closeModal = () => setModalVisible(false);
  const [searchResults, setSearchResults] = useState([]);
  const [flag, setFlag] = useState("A");
  const [selectedReturns, setSelectedReturns] = useState({});
  const [penaltyAmount, setPenaltyAmount] = useState(0);
  const [employeeName, setEmployeeName] = useState([]);
  const [employeeId, setEmployeeId] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const itemsPerPage = 10;

  const offset = currentPage * itemsPerPage;
  const currentItems = searchResults.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(searchResults.length / itemsPerPage);

  const handlePageClick = ({ selected }) => {
    setCurrentPage(selected);
  };
  // or any number you prefer

  const categoryOptions = categories.map((category) => ({
    value: category.id,
    label: category.name, // Label for display
  }));
  // Map sub-categories to React Select options
  const subCategoryOptions = subCategories.map((subCategory) => ({
    value: subCategory.id,
    label: subCategory.name, // Label for display
  }));
  // Handle category change
  const handleCategoryChange = (selectedOption) => {
    const selectedCategoryId = selectedOption ? selectedOption.value : null;
    setBookCategory(selectedCategoryId); // Update selected category
    setBookSubCategory(null); // Reset sub-category when category changes
    console.log("Selected Category Value:", selectedCategoryId);
  };
  // Handle sub-category change
  const handleSubCategoryChange = (selectedOption) => {
    setBookSubCategory(selectedOption ? selectedOption.value : null); // Update selected sub-category
    console.log("Selected Sub Category Value:", selectedOption?.value);
  };

  const handleClear = () => {
    setEmployeeName("");
    setStudentName("");
    setClassId(null);
    setSectionId(null);
    setAddno("");
    setBarCode("");
    setBookCategory("");
    setBookSubCategory("");
    setStudentId("");
    setTeacherId("");
    setBookTitle("");
    setBookBarcode("");
    setFlag("A");
    setSearchResults([]);
    setSelectedReturns({});
    setPenaltyAmount(0);
    setCurrentPage(0);
  };
  const handleOpenModal = () => {
    setShowModal(true);
  };
  const handleCloseModal = () => {
    setShowModal(false);
  };
  const handleClose = () => {
    navigate("/admin/dashboard");
  };
  // select Student =========================================
  const handleSelectStudent = (selectedStudent) => {
    const fullName = [
      selectedStudent.studentBasicDetails.first_name || "",
      selectedStudent.studentBasicDetails.middle_name || "",
      selectedStudent.studentBasicDetails.last_name || "",
    ]
      .filter(Boolean)
      .join(" ");

    // Set studentId when selecting a student (this will trigger the search)
    setStudentId(selectedStudent.studentBasicDetails.id || "");
    setStudentName(fullName);
    setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
    setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);
    setAddno(selectedStudent.studentBasicDetails.school_admission_no || null);
    setBarCode(selectedStudent.studentBasicDetails.school_admission_no || null);

    handleCloseModal();
  };
  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []);
  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]); //===============================================
  useEffect(() => {
    handleAllSearch(); // Fetch initial data when component mounts
  }, [flag]);

  const handleSelectEmployee = (selectedEmployee) => {
    console.log("Selected Employee:", selectedEmployee);

    setEmployeeId(selectedEmployee.id || "");
    setEmployeeName(selectedEmployee.employeeName);
  };

  const academicId = localStorage.getItem("academicSessionId");
  // GetIssueReturnSearchList Api Call
  // const handleAllSearch = async () => {
  //   try {
  //     let queryParams = [];
  //     if (teacherId) queryParams.push(`teacherId=${teacherId}`);
  //     if (studentId) queryParams.push(`studentId=${studentId}`);
  //     if (classId) queryParams.push(`classId=${classId}`);
  //     if (sectionId) queryParams.push(`sectionId=${sectionId}`);
  //     if (bookTitle) queryParams.push(`book_title=${bookTitle}`);
  //     if (bookCategory) queryParams.push(`categoryId=${bookCategory}`);
  //     if (bookSubCategory) queryParams.push(`subcategoryId=${bookSubCategory}`);
  //     if (issueDate) queryParams.push(`issue_date=${issueDate}`);
  //     if (returnDate) queryParams.push(`return_date=${returnDate}`);
  //     if (bookBarcode) queryParams.push(`book_barcode_no=${bookBarcode}`);
  //     if (flag) queryParams.push(`flag=${flag}`);
  //     if (academicyearId) queryParams.push(`academicyearId=${academicId}`);
  //     // Construct the API URL
  //     const apiUrl = `${
  //       ApiUrl.apiurl
  //     }ISSUEBOOK/BOOKISSUESEARCHLIST/?${queryParams.join("&")}`;
  //     const response = await fetch(apiUrl);
  //     const data = await response.json();
  //     if (data.message === "success") {
  //       setSearchResults(data.data); // Update the table with filtered results
  //       setPenaltyAmount(data.Penality_amount); // Update penalty amount
  //     } else {
  //       console.error("Failed to fetch search results:", data.message);
  //       alert("No records found for the given criteria.");
  //       setSearchResults([]); // Clear table if no data is found
  //     }
  //   } catch (error) {
  //     console.error("Error fetching search results:", error);
  //     alert("Error fetching data. Please try again.");
  //   }
  // };
  const handleAllSearch = async () => {
    try {
      if (!academicId) {
        alert("Please select an academic session.");
        setSearchResults([]);
        return;
      }

      const queryParams = new URLSearchParams();
      if (teacherId) queryParams.set("teacherId", teacherId);
      if (studentId) queryParams.set("studentId", studentId);
      if (classId) queryParams.set("classId", classId);
      if (sectionId) queryParams.set("sectionId", sectionId);
      if (bookTitle) queryParams.set("book_title", bookTitle.trim());
      if (bookCategory) queryParams.set("categoryId", bookCategory);
      if (bookSubCategory) queryParams.set("subcategoryId", bookSubCategory);
      if (bookBarcode) queryParams.set("book_barcode_no", bookBarcode.trim());
      if (flag) queryParams.set("flag", flag);
      queryParams.set("academicyearId", academicId);

      const apiUrl = `${
        ApiUrl.apiurl
      }ISSUEBOOK/BOOKISSUESEARCHLIST/?${queryParams.toString()}`;
      const response = await fetch(apiUrl);
      const data = await response.json();

      if (data.message === "success") {
        setSearchResults(data.data);
        setPenaltyAmount(data.Penality_amount);
        setCurrentPage(0);
      } else if (data.message === "No Record Found!") {
        setSearchResults([]);
        setPenaltyAmount(0);
        setCurrentPage(0);
      } else {
        console.error("Failed to fetch search results:", data.message);
        alert(data.error || data.message || "Failed to fetch search results.");
        setSearchResults([]);
      }
    } catch (error) {
      console.error("Error fetching search results:", error);
      alert("Error fetching data. Please try again.");
    }
  };

  // Trigger search when the student name is entered
  const handleStudentNameChange = (e) => {
    setStudentName(e.target.value);
    // If student name is entered, trigger the search with studentId
    if (e.target.value && studentId) {
      handleAllSearch();
    } else {
      // Clear the search results if the input is empty or studentId is not set
      setSearchResults([]);
    }
  };
  // Penalty
  const calculatePenalty = (dueDate, returnDate) => {
    if (!dueDate || !returnDate) return 0;

    const due = new Date(dueDate);
    const ret = new Date(returnDate);

    if (ret <= due) return null; // No penalty if returned on or before due date

    const diffDays = Math.ceil((ret - due) / (1000 * 60 * 60 * 24));
    return diffDays * penaltyAmount;
  };
  // Get current date in YYYY-MM-DD format
  const getCurrentDate = () => {
    return new Date().toISOString().split("T")[0];
  };

  // Book Return Function
  const [returnDates, setReturnDates] = useState({});
  const userId = sessionStorage.getItem("userId");
  const academicYearId = localStorage.getItem("academicSessionId");
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  // Handle checkbox change
  const handleCheckboxChange = (index) => {
    const isSelected = !!selectedReturns[index];

    if (isSelected) {
      // Unselect the book
      setSelectedReturns((prev) => {
        const newReturns = { ...prev };
        delete newReturns[index];
        return newReturns;
      });
    } else {
      // When selecting, default return date to today if not set
      const rd = returnDates[index] || getCurrentDate();
      const penalty = calculatePenalty(searchResults[index].due_date, rd);

      setReturnDates((prev) => ({ ...prev, [index]: rd }));
      setSelectedReturns((prev) => ({ ...prev, [index]: { penalty } }));
    }
  };


  // Handle return date input
const handleReturnDateChange = (index, date) => {
  setReturnDates((prev) => {
    const newDates = { ...prev }; // ✅ use object, not array
    newDates[index] = date;
    return newDates;
  });

  setSelectedReturns((prev) => {
    const newReturns = { ...prev };
    if (newReturns[index]) {
      const penalty = calculatePenalty(searchResults[index].due_date, date);
      newReturns[index] = { ...newReturns[index], penalty };
    }
    return newReturns;
  });
};



  const handleReturnBooks = async () => {
   const selectedBooks = searchResults
     .map((item, index) => {
       if (selectedReturns[index] && returnDates[index]) {
         return {
           studentId: item.student_id || null,
           teacherId: item.teacher_id || null,
           bookIssuedId: item.book_issue_id,
           return_date: returnDates[index],
           returned_by: userId,
           penalty_amount: selectedReturns[index].penalty || 0,
         };
       }
       return null;
     })
     .filter((book) => book !== null);

    if (selectedBooks.length === 0) {
      alert("Please select a book and enter a return date to proceed further.");
      return;
    }

    const requestBody = {
      ReturnBooks: selectedBooks,
      academic_year_id: academicYearId,
      org_id: orgId,
      branch_id: branchId,
    };

    try {
      const response = await fetch(`${ApiUrl.apiurl}ISSUEBOOK/BOOKRETURN/`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(requestBody),
      });

      const data = await response.json();

      if (data.message === "Success") {
        alert("Books returned successfully!");
        handleAllSearch(); // Refresh table with latest search parameters
      } else {
        alert("Failed to return books. Please try again.");
      }
    } catch (error) {
      console.error("Error returning books:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                BOOK MOVEMENTS
              </p>
              <div className="row mb-2  mt-3 mx-0">
                <div className="col-12 p-2 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleAllSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/issue-page")}
                  >
                    Issue
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleReturnBooks}
                  >
                    Return
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              <div className="row p-2 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mb-4">
                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={handleStudentNameChange}
                            style={{ width: "100%" }}
                            disabled
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>
                        <SelectStudentModal
                          show={showModal}
                          handleClose={handleCloseModal}
                          onSelectStudent={handleSelectStudent}
                        />
                      </div>

                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="teacher-name" className="form-label">
                          Teacher Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="teacher-name"
                            className="form-control detail"
                            value={employeeName}
                            placeholder="Enter teacher name"
                            disabled
                            style={{ width: "100%" }}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={openModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                          <SelectStaffModal
                            isVisible={isModalVisible}
                            onClose={closeModal}
                            onSelectEmployee={handleSelectEmployee}
                          />
                        </div>
                      </div>

                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="admission-no" className="form-label">
                          Admission No
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="admission-no"
                            className="form-control detail"
                            value={addNo}
                            placeholder="Enter admission no"
                            disabled
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>

                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="student-barcode" className="form-label">
                          Student Barcode
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            id="student-barcode"
                            className="form-control detail"
                            value={barCode}
                            placeholder="Enter student barcode"
                            disabled
                            style={{ width: "100%" }}
                          />
                        </div>
                      </div>

                      <div className="col-md-3" style={{ minWidth: "250px" }}>
                        <label style={{ fontWeight: "700" }}>Class</label>
                        <Select
                          options={classOptions}
                          // classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId,
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null,
                            )
                          }
                          styles={{
                            control: (base) => ({ ...base, width: "100%" }),
                          }}
                        />
                      </div>

                      <div className="col-md-3" style={{ minWidth: "250px" }}>
                        <label style={{ fontWeight: "700" }}>Section</label>
                        <Select
                          options={sectionOptions}
                          // classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId,
                            ) || null
                          }
                          onChange={(selectedOption) =>
                            setSectionId(
                              selectedOption ? selectedOption.value : null,
                            )
                          }
                          styles={{
                            control: (base) => ({ ...base, width: "100%" }),
                          }}
                        />
                      </div>

                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="book-title" className="form-label">
                          Book Title
                        </label>
                        <input
                          type="text"
                          id="book-title"
                          className="form-control detail"
                          placeholder="Enter book title"
                          ref={bookTitleRef}
                          value={bookTitle}
                          onChange={(e) => setBookTitle(e.target.value)}
                          style={{ width: "100%" }}
                        />
                      </div>

                      <div
                        className="col-12 col-md-3 mb-1"
                        style={{ minWidth: "250px" }}
                      >
                        <label
                          htmlFor="book-accession-no"
                          className="form-label"
                        >
                          Book Accession No
                        </label>
                        <input
                          type="text"
                          id="book-accession-no"
                          className="form-control detail"
                          placeholder="Enter book accession no"
                          value={bookBarcode}
                          onChange={(e) => setBookBarcode(e.target.value)}
                          style={{ width: "100%" }}
                        />
                      </div>

                      <div
                        className="col-12 col-md-3 mb-0"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="category" className="form-label">
                          Category
                        </label>
                        <Select
                          id="category"
                          options={categoryOptions}
                          onChange={handleCategoryChange}
                          placeholder="Select Category"
                          className="detail"
                          // classNamePrefix="react-select-category"
                          value={
                            bookCategory
                              ? categoryOptions.find(
                                  (option) => option.value === bookCategory,
                                )
                              : null
                          }
                          styles={{
                            control: (base) => ({ ...base, width: "100%" }),
                          }}
                        />
                      </div>

                      <div
                        className="col-12 col-md-3 mb-0"
                        style={{ minWidth: "250px" }}
                      >
                        <label htmlFor="sub-category" className="form-label">
                          Sub Category
                        </label>
                        <Select
                          id="sub-category"
                          options={subCategoryOptions}
                          onChange={handleSubCategoryChange}
                          placeholder={
                            subCategoryOptions.length
                              ? "Select Sub Category"
                              : "No Sub Categories Available"
                          }
                          // classNamePrefix="react-select-sub-category"
                          className="detail"
                          value={
                            bookSubCategory
                              ? subCategoryOptions.find(
                                  (option) => option.value === bookSubCategory,
                                )
                              : null
                          }
                          isDisabled={!subCategoryOptions.length}
                          styles={{
                            control: (base) => ({
                              ...base,
                              width: "100%",
                              fontSize: "13px",
                            }),
                          }}
                        />
                      </div>

                      <div className="d-flex align-items-center me-2 mt-2  ">
                        <div className="form-check me-3">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="viewAttendanceType"
                            id="viewIssued"
                            value="I"
                            checked={flag === "I"}
                            onChange={(e) => setFlag(e.target.value)}
                            onClick={handleAllSearch}
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor="viewIssued"
                          >
                            Issued
                          </label>
                        </div>
                        <div className="form-check">
                          <input
                            className="form-check-input"
                            type="radio"
                            name="viewAttendanceType"
                            id="viewAll"
                            value="A"
                            checked={flag === "A"}
                            onChange={(e) => setFlag(e.target.value)}
                            onClick={handleAllSearch}
                          />
                          <label
                            className="form-check-label ms-1"
                            htmlFor="viewAll"
                          >
                            All
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Sr No</th>
                        <th>Name</th>
                        <th>Student BarCode</th>
                        <th>Class</th>
                        <th>Section</th>
                        <th>Book</th>
                        <th>Book Accession No</th>
                        <th>Issue Date</th>
                        <th>Issued By</th>
                        <th>Due Date</th>
                        <th>Return Date</th>
                        <th>Returned By</th>
                        <th>Select</th>
                        <th>Return</th>
                        <th>Penalty</th>
                      </tr>
                    </thead>
                    <tbody>
                      {searchResults.length > 0 ? (
                        currentItems.map((item, index) => {
                          const isReturned = !!item.return_date;
                          const returnDate = returnDates[index];
                          const isChecked = !!selectedReturns[index];
                          const penalty = isChecked
                            ? calculatePenalty(item.due_date, returnDate)
                            : "";
                          return (
                            <tr key={index}>
                              <td>{offset + index + 1}</td>
                              <td>{item.name}</td>
                              <td>{item.student_barcode}</td>
                              <td>{item.className}</td>
                              <td>{item.sectionName}</td>
                              <td>{item.bookName}</td>
                              <td>{item.barcode}</td>
                              <td>
                                {new Date(item.issue_date)
                                  .toISOString()
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join("-")}
                              </td>
                              <td>Librarian</td>
                              <td>
                                {new Date(item.due_date)
                                  .toISOString()
                                  .split("T")[0]
                                  .split("-")
                                  .reverse()
                                  .join("-")}
                              </td>
                              <td>
                                {item.return_date
                                  ? new Date(item.return_date)
                                      .toISOString()
                                      .split("T")[0]
                                      .split("-")
                                      .reverse()
                                      .join("-")
                                  : ""}
                              </td>
                              <td>{item.return_date ? item.name : ""}</td>
                              <td>
                                <input
                                  type="checkbox"
                                  name="bookSelect"
                                  checked={!!selectedReturns[index]}
                                  onChange={() => handleCheckboxChange(index)}
                                  disabled={isReturned}
                                />
                              </td>
                              <td>
                                {!isReturned && (
                                  <input
                                    type="date"
                                    value={returnDate || ""}
                                    onChange={(e) =>
                                      handleReturnDateChange(
                                        index,
                                        e.target.value,
                                      )
                                    }
                                    max={getCurrentDate()}
                                  />
                                )}
                              </td>
                              <td>{penalty}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr>
                          <td colSpan="16" className="text-center">
                            No records found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
              {pageCount > 1 && (
                <div className="d-flex justify-content-center mt-3">
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
